var _style, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _polygon5, _path8, _path9, _path10, _polygon6, _path11, _path12, _path13, _polygon7, _polygon8, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g3, _polygon9, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon10, _polygon11, _path37, _path38, _polygon12, _polygon13, _polygon14, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "250.2px",
    height: "160px",
    viewBox: "0 0 250.2 160",
    style: {
      enableBackground: "new 0 0 250.2 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#898989;}\n\t.st1{opacity:0.45;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st2{opacity:0.45;fill:url(#SVGID_2_);enable-background:new    ;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#676767;}\n\t.st5{opacity:0.53;fill:url(#SVGID_3_);enable-background:new    ;}\n\t.st6{opacity:0.45;}\n\t.st7{fill:url(#SVGID_4_);}\n\t.st8{fill:#454545;}\n\t.st9{opacity:0.53;fill:url(#SVGID_5_);enable-background:new    ;}\n\t.st10{opacity:0.57;fill:url(#SVGID_6_);enable-background:new    ;}\n\t.st11{fill:#B6B6B6;}\n\t.st12{opacity:0.45;fill:url(#SVGID_7_);enable-background:new    ;}\n\t.st13{opacity:0.48;fill:url(#SVGID_8_);enable-background:new    ;}\n\t.st14{opacity:0.45;fill:url(#SVGID_9_);enable-background:new    ;}\n\t.st15{opacity:0.45;fill:url(#SVGID_10_);enable-background:new    ;}\n\t.st16{opacity:0.71;fill:url(#SVGID_11_);enable-background:new    ;}\n\t.st17{opacity:0.53;fill:url(#SVGID_12_);enable-background:new    ;}\n\t.st18{opacity:0.57;fill:url(#SVGID_13_);enable-background:new    ;}\n\t.st19{opacity:0.53;fill:url(#SVGID_14_);enable-background:new    ;}\n\t.st20{opacity:0.57;fill:url(#SVGID_15_);enable-background:new    ;}\n\t.st21{fill:#4D4D4D;}\n\t.st22{opacity:0.54;fill:url(#SVGID_16_);enable-background:new    ;}\n\t.st23{opacity:0.54;fill:url(#SVGID_17_);enable-background:new    ;}\n\t.st24{opacity:0.45;fill:url(#SVGID_18_);enable-background:new    ;}\n\t.st25{opacity:0.45;fill:url(#SVGID_19_);enable-background:new    ;}\n\t.st26{opacity:0.45;fill:url(#SVGID_20_);enable-background:new    ;}\n\t.st27{opacity:0.45;fill:url(#SVGID_21_);enable-background:new    ;}\n\t.st28{fill:url(#SVGID_22_);}\n\t.st29{fill:#777777;}\n\t.st30{opacity:0.27;fill:url(#SVGID_23_);enable-background:new    ;}\n\t.st31{fill:#EA9600;}\n\t.st32{fill:#CE4A00;}\n\t.st33{opacity:0.56;fill:url(#SVGID_24_);enable-background:new    ;}\n\t.st34{opacity:0.25;fill:url(#SVGID_25_);enable-background:new    ;}\n\t.st35{fill:#8CCA00;}\n\t.st36{opacity:0.1;fill:url(#SVGID_26_);enable-background:new    ;}\n\t.st37{opacity:0.1;fill:url(#SVGID_27_);enable-background:new    ;}\n\t.st38{opacity:0.2;fill:url(#SVGID_28_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.4,46.3 78.6,40.4 67.7,34.2 67.7,45.9  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.7,45.9 67.7,34.2 51.7,43.5 61.8,49.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.7113,
    y1: 121.75,
    x2: 78.5878,
    y2: 121.75,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.5,46.3 78.6,40.4 67.7,34.2 67.7,45.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7661,
    y1: 120.25,
    x2: 67.7449,
    y2: 120.25,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "67.7,45.9 67.7,34.2 51.8,43.5 61.8,49.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.2,40.2c-4.5-2.6-6.7-5.9-6.7-9.3v7c0,3.4,2.2,6.7,6.7,9.3l17.3,10v-7L13.2,40.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.5371,
    y1: 117.95,
    x2: 30.5371,
    y2: 117.95,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3012,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M13.2,40.2c-4.5-2.6-6.7-5.9-6.7-9.3v7c0,3.4,2.2,6.7,6.7,9.3l17.3,10v-7L13.2,40.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "46.4,40.9 46.4,47.9 30.5,57.2 30.5,50.1  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,40.9l-15.9,9.3l-17.3-10c-8.8-5.1-8.9-13.4-0.1-18.5L46.4,40.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.5881,
    y1: 126.05,
    x2: 46.4383,
    y2: 126.05,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.5,40.9l-15.9,9.3l-17.3-10c-8.8-5.1-8.9-13.4-0.1-18.5L46.5,40.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.1,38.7c-1.2-0.7-2.2-0.7-3-0.3l-10.9,6.1l0,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0,0,0.1,0,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.2 c2.3,1.3,4.2,4.6,4.2,7.2c0,0.3,0,0.6-0.1,0.9l0,0c-0.1,0.3-0.1,0.5-0.2,0.7l0,0c-0.1,0.2-0.2,0.4-0.4,0.6l0,0 c-0.1,0.2-0.3,0.3-0.5,0.4l0,0l10.9-6.1c0.7-0.4,1.2-1.4,1.2-2.7C74.3,43.3,72.4,40.1,70.1,38.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M62.7,54.3c0.1-0.2,0.3-0.4,0.4-0.6l0,0c0.1-0.2,0.2-0.5,0.2-0.7l0,0c0.1-0.3,0.1-0.6,0.1-0.9 c0-2.6-1.9-5.9-4.2-7.2c-0.1-0.1-0.3-0.2-0.4-0.2c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1s-0.1,0-0.2,0c-0.1,0-0.2,0-0.2-0.1 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0.1c-0.1,0-0.1,0-0.2,0.1c-0.8,0.4-1.2,1.4-1.2,2.7 c0,2.6,1.9,5.9,4.2,7.2c1.2,0.7,2.2,0.7,3,0.3C62.4,54.6,62.5,54.5,62.7,54.3L62.7,54.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.6579,
    y1: 110.2814,
    x2: 63.2981,
    y2: 121.7753,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M70.1,38.7c-1.2-0.7-2.2-0.7-3-0.3l-10.9,6.1l0,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0,0,0.1,0,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.2 c2.3,1.3,4.2,4.6,4.2,7.2c0,0.3,0,0.6-0.1,0.9l0,0c-0.1,0.3-0.1,0.5-0.2,0.7l0,0c-0.1,0.2-0.2,0.4-0.4,0.6l0,0 c-0.1,0.2-0.3,0.3-0.5,0.4l0,0l10.9-6.1c0.7-0.4,1.2-1.4,1.2-2.7C74.3,43.3,72.4,40.1,70.1,38.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.0583,
    y1: 112.2649,
    x2: 63.3992,
    y2: 112.2649,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62.7,54.3c0.1-0.2,0.3-0.4,0.4-0.6l0,0c0.1-0.2,0.2-0.5,0.2-0.7l0,0c0.1-0.3,0.1-0.6,0.1-0.9 c0-2.6-1.9-5.9-4.2-7.2c-0.1-0.1-0.3-0.2-0.4-0.2c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1s-0.1,0-0.2,0c-0.1,0-0.2,0-0.2-0.1 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0.1c-0.1,0-0.1,0-0.2,0.1c-0.8,0.4-1.2,1.4-1.2,2.7 c0,2.6,1.9,5.9,4.2,7.2c1.2,0.7,2.2,0.7,3,0.3C62.4,54.6,62.5,54.5,62.7,54.3L62.7,54.3z"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.1,20.6 37.7,7 37.6,18.7 60.9,32.2 61,32.1  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M61.1,32c0-4.5,0-7,0-11.5V32L61.1,32z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,31.4c0,0.2-0.1,0.4-0.1,0.5c-0.1,0.2-0.2,0.4-0.2,0.6c-0.1,0.2-0.1,0.4-0.2,0.5 c-0.1,0.2-0.2,0.4-0.4,0.6c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.2,0.3-0.4,0.5c-0.2,0.2-0.4,0.4-0.7,0.6 c-0.1,0.1-0.2,0.3-0.4,0.4c-0.3,0.2-0.6,0.5-0.9,0.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.3-0.9,0.6-1.4,0.9v6.8l4.1-2.4l1.6,0.9 c0.2-0.7,0.3-1.4,0.4-2.2V29.5c0,0.2,0,0.4,0,0.6s0,0.4,0,0.5C99.7,31,99.6,31.2,99.6,31.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.7314,
    y1: 124.8,
    x2: 99.8252,
    y2: 124.8,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3012,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M99.6,31.4c0,0.2-0.1,0.4-0.1,0.5c-0.1,0.2-0.2,0.4-0.2,0.6c-0.1,0.2-0.1,0.4-0.2,0.5 c-0.1,0.2-0.2,0.4-0.4,0.6c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.2,0.3-0.4,0.5c-0.2,0.2-0.4,0.4-0.7,0.6 c-0.1,0.1-0.2,0.3-0.4,0.4c-0.3,0.2-0.6,0.5-0.9,0.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.3-0.9,0.6-1.4,0.9v6.8l4.1-2.4l1.6,0.9 c0.2-0.7,0.3-1.4,0.4-2.2V29.5c0,0.2,0,0.4,0,0.6s0,0.4,0,0.5C99.7,31,99.6,31.2,99.6,31.4z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "93.7,45 93.7,38.2 58.7,58.5 58.7,70.2 66.4,65.7 66.4,60.9  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M58.7,58.5l35.1-20.4c0.5-0.3,1-0.6,1.4-0.9c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.2,0.6-0.5,0.9-0.7 c0.1-0.1,0.3-0.3,0.4-0.4c0.2-0.2,0.5-0.4,0.7-0.6c0.1-0.1,0.2-0.3,0.4-0.5c0.2-0.2,0.3-0.4,0.5-0.6c0.1-0.2,0.2-0.3,0.3-0.5 c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.1-0.4,0.2-0.5c0.1-0.2,0.2-0.4,0.2-0.6c0.1-0.2,0.1-0.4,0.1-0.5c0.1-0.2,0.1-0.4,0.1-0.6 s0-0.4,0-0.5c0.3-3.3-1.7-6.7-6.1-9.2L69.4,7c-8.8-5-23-5-31.7,0l23.4,13.5c0,4.5,0,7,0,11.5H61l-0.2,0.1L22.3,54.6l6.9,4 C37.3,63.2,50.5,63.2,58.7,58.5z M67.7,34.2l10.8,6.3l-10.1,5.9l-5.9,3.4l-0.8-0.4l-10.1-5.8L67.7,34.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,58.5l-6.9-4v11.7l6.9,4c8.2,4.7,21.4,4.7,29.5,0V58.5C50.5,63.2,37.3,63.2,29.2,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.2579,
    y1: 97.8875,
    x2: 58.6579,
    y2: 97.8875,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05909201,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1408,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4523,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5477,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#BABABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    style: {
      stopColor: "#939393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7854,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8612,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9339,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M29.2,58.5l-6.9-4v11.7l6.9,4c8.2,4.7,21.4,4.7,29.5,0V58.5C50.5,63.2,37.3,63.2,29.2,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.6706,
    y1: 142.4,
    x2: 61.0962,
    y2: 142.4,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3012,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "61.1,20.6 37.7,7 37.7,18.7 60.9,32.2 61.1,32.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.7,
    y1: 107.8,
    x2: 93.8,
    y2: 107.8,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "93.7,45 93.8,38.2 58.7,58.5 58.7,70.2 66.4,65.7 66.5,60.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3,
    y1: 129.3562,
    x2: 99.8293,
    y2: 129.3562,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M58.7,58.5l35.1-20.4c0.5-0.3,1-0.6,1.4-0.9c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.2,0.6-0.5,0.9-0.7 c0.1-0.1,0.3-0.3,0.4-0.4c0.2-0.2,0.5-0.4,0.7-0.6c0.1-0.1,0.2-0.3,0.4-0.5c0.2-0.2,0.3-0.4,0.5-0.6c0.1-0.2,0.2-0.3,0.3-0.5 c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.2-0.4,0.2-0.5c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.1-0.4,0.1-0.5c0.1-0.2,0.1-0.4,0.1-0.6 s0-0.4,0-0.5c0.3-3.3-1.7-6.7-6.1-9.2L69.4,7c-8.8-5-23-5-31.7,0l23.4,13.5c0,4.5,0,7,0,11.5H61l-0.2,0.1L22.3,54.6l6.9,4 C37.4,63.2,50.6,63.2,58.7,58.5z M67.7,34.2l10.8,6.3l-10.1,5.9l-5.9,3.4l-0.8-0.4l-10.1-5.8L67.7,34.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.6,62.1c-0.7-0.4-1.3-0.4-1.7-0.2l-6.2,3.5l0,0h0.1h0.1H21h0.1h0.1h0.1h0.1h0.1h0.1h0.1h0.1h0.1 c0.1,0,0.1,0,0.2,0.1h0.1c0.1,0,0.2,0.1,0.2,0.1c1.3,0.8,2.4,2.6,2.4,4.1c0,0.2,0,0.4,0,0.5l0,0c0,0.2-0.1,0.3-0.1,0.4l0,0 c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c-0.1,0.1-0.2,0.2-0.3,0.2l0,0l6.2-3.5c0.4-0.2,0.7-0.8,0.7-1.5C30.9,64.7,29.9,62.8,28.6,62.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M24.3,70.9c0.1-0.1,0.2-0.2,0.2-0.3l0,0c0.1-0.1,0.1-0.3,0.1-0.4l0,0c0-0.2,0-0.3,0-0.5 c0-1.5-1.1-3.3-2.4-4.1c-0.1,0-0.2-0.1-0.2-0.1h-0.1c-0.1,0-0.1,0-0.2-0.1h-0.1h-0.1h-0.1h-0.1h-0.1h-0.1H21h-0.1h-0.1h-0.1h-0.1 h-0.1c-0.4,0.2-0.7,0.8-0.7,1.5c0,1.5,1.1,3.3,2.4,4.1c0.7,0.4,1.3,0.4,1.7,0.2C24.2,71.1,24.3,71,24.3,70.9L24.3,70.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.7479,
    y1: 92.5607,
    x2: 24.703,
    y2: 99.0904,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M28.6,62.1c-0.7-0.4-1.3-0.4-1.7-0.2l-6.2,3.5l0,0h0.1h0.1H21h0.1h0.1h0.1h0.1h0.1h0.1h0.1h0.1h0.1 c0.1,0,0.1,0,0.2,0.1h0.1c0.1,0,0.2,0.1,0.2,0.1c1.3,0.8,2.4,2.6,2.4,4.1c0,0.2,0,0.4,0,0.5l0,0c0,0.2-0.1,0.3-0.1,0.4l0,0 c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c-0.1,0.1-0.2,0.2-0.3,0.2l0,0l6.2-3.5c0.4-0.2,0.7-0.8,0.7-1.5C30.9,64.7,29.9,62.8,28.6,62.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.0051,
    y1: 93.6343,
    x2: 24.7431,
    y2: 93.6343,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M24.3,70.9c0.1-0.1,0.2-0.2,0.2-0.3l0,0c0.1-0.1,0.1-0.3,0.1-0.4l0,0c0-0.2,0-0.3,0-0.5 c0-1.5-1.1-3.3-2.4-4.1c-0.1,0-0.2-0.1-0.2-0.1h-0.1c-0.1,0-0.1,0-0.2-0.1h-0.1h-0.1h-0.1h-0.1h-0.1h-0.1H21h-0.1h-0.1h-0.1h-0.1 h-0.1c-0.4,0.2-0.7,0.8-0.7,1.5c0,1.5,1.1,3.3,2.4,4.1c0.7,0.4,1.3,0.4,1.7,0.2C24.2,71.1,24.3,71,24.3,70.9L24.3,70.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.7,61.6c-1.4-0.8-2.7-0.9-3.6-0.4l-2.7,1.6l0,0c0.1,0,0.1-0.1,0.2-0.1s0.1-0.1,0.2-0.1s0.1,0,0.2-0.1 c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0s0.2,0,0.2,0c0.1,0,0.1,0,0.2,0s0.2,0,0.2,0c0.1,0,0.1,0,0.2,0 s0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.3,0.2,0.5,0.3 c2.8,1.6,5.1,5.6,5.1,8.9c0,0.4,0,0.8-0.1,1.1l0,0c-0.1,0.3-0.2,0.6-0.3,0.9l0,0c-0.1,0.3-0.3,0.5-0.5,0.7l0,0 c-0.2,0.2-0.4,0.4-0.6,0.5l0,0l2.7-1.6c0.9-0.5,1.5-1.7,1.5-3.3C28.9,67.2,26.6,63.2,23.7,61.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M25.3,74.8c0.2-0.2,0.3-0.4,0.5-0.7l0,0c0.1-0.3,0.2-0.6,0.3-0.9l0,0c0.1-0.3,0.1-0.7,0.1-1.1 c0-3.3-2.3-7.2-5.1-8.9c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0s-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0s-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0s-0.2,0-0.2,0 c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1s-0.1,0.1-0.2,0.1c-0.9,0.5-1.5,1.7-1.5,3.3 c0,3.3,2.3,7.2,5.1,8.8c1.4,0.8,2.7,0.9,3.7,0.3C24.9,75.2,25.1,75,25.3,74.8L25.3,74.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.1147,
    y1: 87.8053,
    x2: 20.8825,
    y2: 101.1702,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M23.7,61.6c-1.4-0.8-2.7-0.9-3.6-0.4l-2.7,1.6l0,0c0.1,0,0.1-0.1,0.2-0.1s0.1-0.1,0.2-0.1s0.1,0,0.2-0.1 c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0s0.2,0,0.2,0c0.1,0,0.1,0,0.2,0s0.2,0,0.2,0c0.1,0,0.1,0,0.2,0 s0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.3,0.2,0.5,0.3 c2.8,1.6,5.1,5.6,5.1,8.9c0,0.4,0,0.8-0.1,1.1l0,0c-0.1,0.3-0.2,0.6-0.3,0.9l0,0c-0.1,0.3-0.3,0.5-0.5,0.7l0,0 c-0.2,0.2-0.4,0.4-0.6,0.5l0,0l2.7-1.6c0.9-0.5,1.5-1.7,1.5-3.3C28.9,67.2,26.6,63.2,23.7,61.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.8895,
    y1: 92.9071,
    x2: 26.1412,
    y2: 92.9071,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M25.3,74.8c0.2-0.2,0.3-0.4,0.5-0.7l0,0c0.1-0.3,0.2-0.6,0.3-0.9l0,0c0.1-0.3,0.1-0.7,0.1-1.1 c0-3.3-2.3-7.2-5.1-8.9c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0s-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0s-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0s-0.2,0-0.2,0 c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1s-0.1,0.1-0.2,0.1c-0.9,0.5-1.5,1.7-1.5,3.3 c0,3.3,2.3,7.2,5.1,8.8c1.4,0.8,2.7,0.9,3.7,0.3C24.9,75.2,25.1,75,25.3,74.8L25.3,74.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "101,46.2 101,53.2 69.6,71.5 69.6,64.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "69.6,64.5 69.6,71.5 61.8,66.6 61.8,59.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101,46.2 69.6,64.5 61.8,59.6 92.6,41.7  "
  }))))), /*#__PURE__*/React.createElement("g", null, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "66.4,60.9 66.4,65.7 66.4,72.6 194.4,151.8 194.4,140.1  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.4,121.9c0.1-0.1,0.3-0.3,0.4-0.4C197.6,121.6,197.5,121.8,197.4,121.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.9,122.4c-0.1,0.1-0.2,0.3-0.4,0.5l0,0C196.7,122.7,196.8,122.5,196.9,122.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.9,120.7c-0.1,0.1-0.3,0.2-0.4,0.3C198.6,120.9,198.7,120.8,198.9,120.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,54.4l-5.3,3.1c-3.7,2.2-3.7,5.6,0.1,7.8l91.1,52.6c3.7,2.1,9.7,2.2,13.4,0l5.3-3.1c3.7-2.1,3.7-5.6,0-7.8 l-91.1-52.6C101.7,52.2,95.7,52.2,92,54.4z M188.6,110.2l-5.4,3.1L95.7,62.7l5.3-3.1L188.6,110.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.9,126.7c0-0.2,0-0.3,0-0.5C194.9,126.4,194.9,126.6,194.9,126.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.5,122.8L196.5,122.8L196.5,122.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.1,125.7c0-0.2,0.1-0.3,0.1-0.5C195.1,125.4,195.1,125.6,195.1,125.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.9,123.8c0.1-0.2,0.2-0.3,0.3-0.5C196.1,123.5,196,123.6,195.9,123.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.4,124.7c0.1-0.2,0.1-0.3,0.2-0.5C195.5,124.4,195.5,124.6,195.4,124.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.9,120.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.5,0.3-0.7,0.5c-0.2,0.1-0.3,0.3-0.4,0.4 c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1,0.1-0.2,0.3-0.4,0.5l0,0c-0.1,0.2-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.3-0.3,0.5s-0.2,0.3-0.3,0.5 s-0.1,0.3-0.2,0.5c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1,0.2-0.1,0.3-0.1,0.5s-0.1,0.3-0.1,0.5s0,0.3,0,0.5c-0.2,2.2,0.8,4.4,3,6.4 c0.6-0.5,1.3-1,2.1-1.5c7-4.1,18.5-4.1,25.6,0c0.9,0.5,1.6,1,2.3,1.6c2.1-1.8,3.1-3.8,3.1-5.9c0-0.2,0-0.4,0-0.5 c0-0.2,0-0.3,0-0.5s-0.1-0.4-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.2-0.1-0.4-0.2-0.5c-0.1-0.2-0.1-0.3-0.2-0.5 c-0.1-0.2-0.2-0.4-0.3-0.5s-0.2-0.3-0.3-0.4c-0.1-0.2-0.3-0.4-0.4-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.2-0.4-0.3-0.5-0.5 c-0.1-0.1-0.2-0.3-0.4-0.4c-0.2-0.2-0.5-0.4-0.8-0.6c-0.1-0.1-0.2-0.2-0.3-0.2c-0.4-0.3-0.8-0.5-1.2-0.8c-7.1-4.1-18.5-4.1-25.6,0 C199.7,120.1,199.2,120.4,198.9,120.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.6,129.2c0,0.2,0,0.5-0.1,0.7c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.3-0.2,0.6-0.4,0.9 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.3-0.3,0.6-0.5,0.9c-0.1,0.2-0.2,0.4-0.4,0.7s-0.4,0.6-0.7,0.9c-0.2,0.2-0.3,0.4-0.5,0.6 c-0.3,0.3-0.6,0.6-0.9,0.9c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.7,0.6-1.1,0.9c-0.2,0.2-0.4,0.3-0.6,0.5c-0.6,0.4-1.3,0.9-2,1.3 c-11.2,6.5-29.5,6.5-40.8,0v11.7c11.3,6.5,29.6,6.5,40.8,0c5.6-3.2,8.4-7.5,8.4-11.7v-11.7C243.6,128.7,243.6,129,243.6,129.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.875,
    y1: 36.7375,
    x2: 231,
    y2: 36.7375,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05909201,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1408,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4523,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5477,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#BABABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    style: {
      stopColor: "#939393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7854,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8612,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9339,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M198.9,120.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.5,0.3-0.7,0.5c-0.2,0.1-0.3,0.3-0.4,0.4 c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1,0.1-0.2,0.3-0.4,0.5l0,0c-0.1,0.2-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.3-0.3,0.5s-0.2,0.3-0.3,0.5 s-0.1,0.3-0.2,0.5c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1,0.2-0.1,0.3-0.1,0.5s-0.1,0.3-0.1,0.5s0,0.3,0,0.5c-0.2,2.2,0.8,4.4,3,6.4 c0.6-0.5,1.3-1,2.1-1.5c7-4.1,18.5-4.1,25.6,0c0.9,0.5,1.6,1,2.3,1.6c2.1-1.8,3.1-3.8,3.1-5.9c0-0.2,0-0.4,0-0.5 c0-0.2,0-0.3,0-0.5s-0.1-0.4-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.2-0.1-0.4-0.2-0.5c-0.1-0.2-0.1-0.3-0.2-0.5 c-0.1-0.2-0.2-0.4-0.3-0.5s-0.2-0.3-0.3-0.4c-0.1-0.2-0.3-0.4-0.4-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.2-0.4-0.3-0.5-0.5 c-0.1-0.1-0.2-0.3-0.4-0.4c-0.2-0.2-0.5-0.4-0.8-0.6c-0.1-0.1-0.2-0.2-0.3-0.2c-0.4-0.3-0.8-0.5-1.2-0.8c-7.1-4.1-18.5-4.1-25.6,0 C199.7,120.1,199.2,120.4,198.9,120.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.4023,
    y1: 19.1625,
    x2: 243.6322,
    y2: 19.1625,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05909201,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1408,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4523,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5477,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#BABABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    style: {
      stopColor: "#939393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7854,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8612,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9339,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M243.6,129.2c0,0.2,0,0.5-0.1,0.7c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.3-0.2,0.6-0.4,0.9 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.3-0.3,0.6-0.5,0.9c-0.1,0.2-0.2,0.4-0.4,0.7s-0.4,0.6-0.7,0.9c-0.2,0.2-0.3,0.4-0.5,0.6 c-0.3,0.3-0.6,0.6-0.9,0.9c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.7,0.6-1.1,0.9c-0.2,0.2-0.4,0.3-0.6,0.5c-0.6,0.4-1.3,0.9-2,1.3 c-11.2,6.5-29.5,6.5-40.8,0v11.7c11.3,6.5,29.6,6.5,40.8,0c5.6-3.2,8.4-7.5,8.4-11.7v-11.7C243.6,128.7,243.6,129,243.6,129.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M93.7,45L66.4,60.9l17.5,10.8l2.8,1.8l107.7,66.7c11.3,6.5,29.6,6.5,40.8,0c0.7-0.4,1.4-0.8,2-1.3 c0.2-0.2,0.4-0.3,0.6-0.5c0.4-0.3,0.8-0.6,1.1-0.9c0.2-0.2,0.4-0.4,0.6-0.6c0.3-0.3,0.6-0.6,0.9-0.9c0.2-0.2,0.3-0.4,0.5-0.6 c0.2-0.3,0.5-0.6,0.7-0.9c0.2-0.2,0.3-0.4,0.4-0.7c0.2-0.3,0.4-0.6,0.5-0.9c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.3,0.3-0.6,0.4-0.9 c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.6,0.2-0.9c0-0.2,0-0.5,0.1-0.7c0.4-4.6-2.4-9.2-8.5-12.7l-135.7-73l-1.6-0.9L93.7,45z  M225.7,119.9c0.4,0.3,0.9,0.5,1.2,0.8c0.1,0.1,0.2,0.2,0.3,0.2c0.3,0.2,0.5,0.4,0.8,0.6c0.1,0.1,0.3,0.2,0.4,0.4 c0.2,0.2,0.4,0.3,0.5,0.5c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.4,0.5c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.2,0.4,0.3,0.5 c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.3,0.1,0.5s0.1,0.4,0.1,0.5c0,0.2,0,0.3,0,0.5s0,0.4,0,0.5 c0,2.1-1,4.1-3.1,5.9c-0.6,0.5-1.3,1-2.1,1.5c-7,4.1-18.5,4.1-25.6,0c-0.9-0.5-1.6-1-2.3-1.6c-2.2-1.9-3.2-4.1-3-6.4 c0-0.2,0-0.3,0-0.5s0.1-0.3,0.1-0.5s0.1-0.3,0.1-0.5c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.3,0.3-0.5 s0.2-0.3,0.3-0.5s0.2-0.3,0.4-0.5l0,0c0.1-0.2,0.2-0.3,0.4-0.5c0.1-0.2,0.3-0.3,0.5-0.5c0.1-0.1,0.3-0.3,0.4-0.4 c0.2-0.2,0.4-0.3,0.7-0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.3,0.8-0.5,1.2-0.8C207.1,115.8,218.6,115.8,225.7,119.9z M196.5,107 c3.7,2.1,3.7,5.6,0,7.8l-5.3,3.1c-3.7,2.2-9.7,2.1-13.4,0L86.7,65.2c-3.7-2.2-3.8-5.6-0.1-7.8l5.3-3.1c3.7-2.1,9.7-2.1,13.5,0 L196.5,107z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "183.3,113.3 188.6,110.2 101,59.6 95.7,62.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.4,
    y1: 55.65,
    x2: 194.5,
    y2: 55.65,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3012,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "66.5,60.9 66.4,65.7 66.4,72.6 194.4,151.8 194.5,140.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.9374,
    y1: 75.8686,
    x2: 199.375,
    y2: 75.8686,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M92,54.4l-5.3,3.1c-3.7,2.2-3.7,5.6,0.1,7.8l91.1,52.6c3.7,2.1,9.7,2.2,13.4,0l5.3-3.1 c3.7-2.1,3.7-5.6,0-7.8l-91.1-52.6C101.7,52.2,95.7,52.2,92,54.4z M188.7,110.2l-5.3,3.1L95.7,62.7l5.4-3.1L188.7,110.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.5,
    y1: 68.2625,
    x2: 243.8375,
    y2: 68.2625,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M93.7,45L66.5,60.9L84,71.7l2.8,1.8l107.7,66.7c11.3,6.5,29.6,6.5,40.8,0c0.7-0.4,1.4-0.8,2-1.3 c0.2-0.2,0.4-0.3,0.6-0.5c0.4-0.3,0.8-0.6,1.1-0.9c0.2-0.2,0.4-0.4,0.6-0.6c0.3-0.3,0.6-0.6,0.9-0.9c0.2-0.2,0.3-0.4,0.5-0.6 c0.2-0.3,0.5-0.6,0.7-0.9c0.2-0.2,0.3-0.4,0.4-0.7c0.2-0.3,0.4-0.6,0.5-0.9c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.3,0.3-0.6,0.4-0.9 c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.6,0.2-0.9c0-0.2,0-0.5,0.1-0.7c0.4-4.6-2.4-9.2-8.5-12.7l-135.7-73L98,42.4L93.7,45z  M225.7,119.9c0.4,0.3,0.9,0.5,1.2,0.8c0.1,0.1,0.2,0.2,0.3,0.2c0.3,0.2,0.5,0.4,0.8,0.6c0.1,0.1,0.3,0.2,0.4,0.4 c0.2,0.2,0.4,0.3,0.5,0.5c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.4,0.5c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.2,0.4,0.3,0.5 c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.3,0.1,0.5s0.1,0.4,0.1,0.5c0,0.2,0,0.3,0,0.5s0,0.4,0,0.5 c0,2.1-1,4.1-3.1,5.9c-0.6,0.5-1.3,1-2.1,1.5c-7,4.1-18.5,4.1-25.6,0c-0.9-0.5-1.6-1-2.3-1.6c-2.2-1.9-3.2-4.1-3-6.4 c0-0.2,0-0.3,0-0.5s0.1-0.3,0.1-0.5s0.1-0.3,0.1-0.5c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.3,0.3-0.5 s0.2-0.3,0.3-0.5s0.2-0.3,0.4-0.5l0,0c0.1-0.2,0.2-0.3,0.4-0.5c0.1-0.2,0.3-0.3,0.5-0.5c0.1-0.1,0.3-0.3,0.4-0.4 c0.2-0.2,0.4-0.3,0.7-0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.3,0.8-0.5,1.2-0.8C207.2,115.8,218.6,115.8,225.7,119.9z M196.5,107 c3.7,2.1,3.7,5.6,0,7.8l-5.3,3.1c-3.7,2.2-9.7,2.1-13.4,0l-91-52.7c-3.7-2.2-3.8-5.6-0.1-7.8l5.3-3.1c3.7-2.1,9.7-2.1,13.5,0 L196.5,107z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.7,
    y1: 75.55,
    x2: 188.7,
    y2: 75.55,
    gradientTransform: "matrix(1 0 0 -1 0 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "183.3,113.3 188.7,110.2 101.1,59.6 95.7,62.7  "
  })))), /*#__PURE__*/React.createElement("g", null, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "164.3,57.8 231.4,18.5 241.3,15.6 250.2,4.2 243.1,0 225.4,6.4 220.9,12.6 158.2,49.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -2956.5105,
    y1: 127.607,
    x2: -2948.5779,
    y2: 141.3469,
    gradientTransform: "matrix(-1 0 0 -1 -2747.8403 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "164.3,57.8 231.4,18.5 241.3,15.6 250.2,4.2 243.1,0 225.4,6.4 220.9,12.6 158.2,49.1  "
  })), /*#__PURE__*/React.createElement("g", null, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M159.7,60.8L159.7,60.8c-0.6-1.4-1.3-2.8-2.1-4.1C158.4,58.1,159.1,59.4,159.7,60.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -2912.1311,
    y1: 103.25,
    x2: -2890.9409,
    y2: 103.25,
    gradientTransform: "matrix(-1 0 0 -1 -2747.8403 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6988,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M159.7,60.8L159.7,60.8c-0.6-1.4-1.3-2.8-2.1-4.1C158.4,58.1,159.1,59.4,159.7,60.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M131.7,41.7L131.7,41.7l6.3-3.6c0,0,0.1,0,0.1-0.1c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.6-0.2,1-0.3 c0.2-0.1,0.4-0.1,0.7-0.2h0.1c0.1,0,0.1,0,0.2-0.1c0.4-0.1,0.7-0.1,1.1-0.1c0.1,0,0.3,0,0.4,0l0,0c0.2,0,0.4,0,0.5,0s0.1,0,0.2,0 c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.7,0.1c0.5,0.1,1.1,0.2,1.6,0.3c0.2,0.1,0.5,0.2,0.7,0.2 c0.2,0.1,0.4,0.1,0.6,0.2c0.3,0.1,0.5,0.2,0.8,0.3c0.8,0.3,1.7,0.8,2.6,1.3c1.2,0.7,2.3,1.5,3.4,2.4c0.4,0.3,0.7,0.6,1.1,0.9 c0.5,0.5,1.1,0.9,1.6,1.4h-0.1c2.8,2.8,5.3,6.1,7.2,9.7c0.4,0.7,0.7,1.3,1.1,2h0.1c0.2,0.5,0.4,0.9,0.6,1.4v0.1v0.1 c0.2,0.5,0.5,1.1,0.7,1.6c0.2,0.6,0.4,1.1,0.6,1.7c0.1,0.3,0.2,0.6,0.3,0.9c0,0.1,0.1,0.2,0.1,0.4c0.1,0.2,0.1,0.4,0.2,0.6 c0.2,0.7,0.4,1.4,0.5,2.1c0.1,0.4,0.1,0.8,0.2,1.3c0,0.2,0.1,0.4,0.1,0.7c0,0.2,0.1,0.4,0.1,0.6c0.2,1.2,0.2,2.4,0.2,3.6 c0,5.4-1.9,9.2-4.8,11.2c-0.2,0.1-0.3,0.3-0.5,0.4l-6.3,3.7c0.5-0.3,0.8-0.7,1.2-1c0.3-0.3,0.7-0.5,0.9-0.8c0.4-0.4,0.7-1,1-1.5 c0.2-0.4,0.5-0.6,0.7-1c0.3-0.6,0.5-1.4,0.7-2.2c0.1-0.4,0.3-0.7,0.4-1.1c0.2-1.2,0.4-2.5,0.4-4c0-3-0.5-6.1-1.5-9.2l0,0 c-0.1-0.2-0.2-0.4-0.2-0.6c-0.4-1.3-0.8-2.5-1.4-3.8l0,0c-0.6-1.4-1.3-2.8-2.1-4.1s-1.6-2.6-2.5-3.8l0,0c-2.1-2.9-4.5-5.5-7-7.5 l0,0c-1.1-0.9-2.2-1.7-3.4-2.4c-0.5-0.3-1-0.6-1.5-0.8c-0.2-0.1-0.4-0.2-0.5-0.2l0,0c-0.4-0.2-0.8-0.3-1.2-0.5 c-0.2-0.1-0.4-0.2-0.7-0.2l0,0c-0.3-0.1-0.5-0.1-0.8-0.2c-0.8-0.2-1.7-0.4-2.4-0.5l0,0c-0.4,0-0.7,0-1.1,0.1c-0.6,0-1.3,0-1.9,0.1 c0,0,0,0-0.1,0c-0.4,0.1-0.7,0.3-1.1,0.4C132.8,41.3,132.2,41.4,131.7,41.7L131.7,41.7L131.7,41.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M151.5,82.9c2.5-1.5,4.1-4.6,4.1-9.1c0-0.9-0.1-1.8-0.2-2.8c0-0.2-0.1-0.3-0.1-0.5s-0.1-0.3-0.1-0.5 c-0.1-0.3-0.1-0.7-0.2-1c-0.1-0.5-0.2-1.1-0.4-1.6c0-0.2-0.1-0.3-0.1-0.5c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.1-0.4-0.2-0.7 c-0.1-0.4-0.3-0.9-0.5-1.3s-0.3-0.8-0.5-1.3c0,0,0,0,0-0.1c0,0,0,0,0-0.1c-0.2-0.4-0.3-0.7-0.5-1.1c-0.2-0.4-0.4-0.8-0.6-1.2 c-0.2-0.3-0.4-0.7-0.6-1c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.5-0.8-0.7-1.2c-0.3-0.4-0.5-0.8-0.8-1.2 c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.3-0.4-0.5c-0.4-0.5-0.8-0.9-1.1-1.4c-0.2-0.2-0.4-0.4-0.5-0.6 c-0.2-0.2-0.3-0.3-0.5-0.5s-0.4-0.4-0.5-0.6c-0.4-0.4-0.8-0.7-1.2-1.1c-0.3-0.2-0.5-0.5-0.8-0.7c-0.9-0.7-1.8-1.3-2.7-1.8 c-0.7-0.4-1.3-0.7-2-1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.3-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2c-0.4-0.1-0.8-0.2-1.2-0.3 c-0.2,0-0.4,0-0.5-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0.1-0.9,0.1c-0.1,0-0.1,0-0.2,0h-0.1 c-0.2,0-0.3,0.1-0.5,0.1c-0.3,0.1-0.5,0.2-0.7,0.3s-0.5,0.2-0.7,0.3h-0.1l-4.9,2.8c0.2-2.5,0.9-4.5,1.9-6.2c0.7-1.2,1.7-2.3,2.8-3 c0.2-0.1,0.3-0.3,0.5-0.4c0.5-0.3,1-0.4,1.5-0.6c0.4-0.1,0.7-0.3,1.1-0.4c0.6-0.1,1.3-0.1,1.9-0.1c0.4,0,0.7-0.1,1.1-0.1 c0.8,0.1,1.6,0.3,2.4,0.5c0.3,0.1,0.5,0.1,0.8,0.2c0.2,0.1,0.4,0.2,0.7,0.2c0.4,0.1,0.8,0.4,1.2,0.6l0,0c0.2,0.1,0.4,0.2,0.6,0.3 c0.5,0.2,1,0.4,1.5,0.7c1.2,0.7,2.3,1.5,3.4,2.4c2.6,2.1,5,4.6,7,7.5l0,0c0.9,1.2,1.7,2.5,2.5,3.8s1.5,2.7,2.1,4.1 c0.5,1.2,1,2.5,1.4,3.8c0.1,0.2,0.2,0.4,0.2,0.6c1,3.1,1.5,6.2,1.5,9.2c0,1.4-0.1,2.8-0.4,4c-0.1,0.4-0.3,0.8-0.4,1.1 c-0.2,0.7-0.4,1.5-0.7,2.2c-0.2,0.4-0.5,0.7-0.7,1c-0.3,0.5-0.6,1.1-1,1.5c-0.3,0.3-0.6,0.5-0.9,0.8c-0.5,0.4-1,0.9-1.6,1.2 c-2.8,1.5-6.4,1.3-10.5-0.5L151.5,82.9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M115.2,92.6c-0.4-0.2-0.8-0.4-1.1-0.4c-0.1,0-0.1,0-0.1,0l0.5-0.3c1.1-0.6,1.3-2.5,0.3-4.5 c-2.1-4.6-4.7-9-7.8-13c-0.5-0.7-1.1-1.2-1.7-1.5c-0.8-0.5-1.6-0.6-2.2-0.2l-0.6,0.3v-0.1c0.6-1.6-0.3-4.2-2-5.7 c-0.2-0.2-0.5-0.4-0.7-0.6l26.8-15.3l4.9-2.8h0.1c0.2-0.1,0.5-0.2,0.7-0.3s0.5-0.2,0.7-0.3c0.2,0,0.3-0.1,0.5-0.1h0.1 c0.1,0,0.1,0,0.2,0c0.3,0,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.9,0c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.2,0,0.4,0,0.5,0.1 c0.4,0.1,0.8,0.1,1.2,0.3c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.6,0.3,1.3,0.6,2,1 c0.9,0.5,1.8,1.2,2.7,1.8c0.3,0.2,0.5,0.5,0.8,0.7c0.4,0.4,0.8,0.7,1.2,1.1c0.2,0.2,0.4,0.4,0.5,0.6c0.2,0.2,0.3,0.3,0.5,0.5 s0.4,0.4,0.5,0.6c0.4,0.5,0.8,0.9,1.1,1.4c0.1,0.2,0.2,0.3,0.4,0.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.3,0.4,0.5 c0.3,0.4,0.6,0.8,0.8,1.2c0.3,0.4,0.5,0.8,0.7,1.2c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0.2,0.3,0.4,0.7,0.6,1 c0.2,0.4,0.4,0.8,0.6,1.2c0.2,0.4,0.3,0.7,0.5,1.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0.2,0.4,0.4,0.8,0.5,1.3c0.2,0.4,0.3,0.9,0.5,1.3 c0.1,0.2,0.1,0.4,0.2,0.7c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0.1,0.3,0.1,0.5c0.1,0.5,0.3,1.1,0.4,1.6c0.1,0.3,0.1,0.7,0.2,1 c0,0.2,0.1,0.3,0.1,0.5s0.1,0.3,0.1,0.5c0.1,0.9,0.2,1.9,0.2,2.8c0,4.5-1.6,7.6-4.1,9.1l-4.9,2.9l-27.3,15.6 c-0.3-1.6-0.6-3.1-1.1-4.7C117.7,94.9,116.5,93.4,115.2,92.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -2914.7219,
    y1: 81.4321,
    x2: -2889.0916,
    y2: 125.8251,
    gradientTransform: "matrix(-1 0 0 -1 -2747.8403 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M131.7,41.7L131.7,41.7l6.3-3.6c0,0,0.1,0,0.1-0.1c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.6-0.2,1-0.3 c0.2-0.1,0.4-0.1,0.7-0.2h0.1c0.1,0,0.1,0,0.2-0.1c0.4-0.1,0.7-0.1,1.1-0.1c0.1,0,0.3,0,0.4,0l0,0c0.2,0,0.4,0,0.5,0s0.1,0,0.2,0 c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.7,0.1c0.5,0.1,1.1,0.2,1.6,0.3c0.2,0.1,0.5,0.2,0.7,0.2 c0.2,0.1,0.4,0.1,0.6,0.2c0.3,0.1,0.5,0.2,0.8,0.3c0.8,0.3,1.7,0.8,2.6,1.3c1.2,0.7,2.3,1.5,3.4,2.4c0.4,0.3,0.7,0.6,1.1,0.9 c0.5,0.5,1.1,0.9,1.6,1.4h-0.1c2.8,2.8,5.3,6.1,7.2,9.7c0.4,0.7,0.7,1.3,1.1,2h0.1c0.2,0.5,0.4,0.9,0.6,1.4v0.1v0.1 c0.2,0.5,0.5,1.1,0.7,1.6c0.2,0.6,0.4,1.1,0.6,1.7c0.1,0.3,0.2,0.6,0.3,0.9c0,0.1,0.1,0.2,0.1,0.4c0.1,0.2,0.1,0.4,0.2,0.6 c0.2,0.7,0.4,1.4,0.5,2.1c0.1,0.4,0.1,0.8,0.2,1.3c0,0.2,0.1,0.4,0.1,0.7c0,0.2,0.1,0.4,0.1,0.6c0.2,1.2,0.2,2.4,0.2,3.6 c0,5.4-1.9,9.2-4.8,11.2c-0.2,0.1-0.3,0.3-0.5,0.4l-6.3,3.7c0.5-0.3,0.8-0.7,1.2-1c0.3-0.3,0.7-0.5,0.9-0.8c0.4-0.4,0.7-1,1-1.5 c0.2-0.4,0.5-0.6,0.7-1c0.3-0.6,0.5-1.4,0.7-2.2c0.1-0.4,0.3-0.7,0.4-1.1c0.2-1.2,0.4-2.5,0.4-4c0-3-0.5-6.1-1.5-9.2l0,0 c-0.1-0.2-0.2-0.4-0.2-0.6c-0.4-1.3-0.8-2.5-1.4-3.8l0,0c-0.6-1.4-1.3-2.8-2.1-4.1s-1.6-2.6-2.5-3.8l0,0c-2.1-2.9-4.5-5.5-7-7.5 l0,0c-1.1-0.9-2.2-1.7-3.4-2.4c-0.5-0.3-1-0.6-1.5-0.8c-0.2-0.1-0.4-0.2-0.5-0.2l0,0c-0.4-0.2-0.8-0.3-1.2-0.5 c-0.2-0.1-0.4-0.2-0.7-0.2l0,0c-0.3-0.1-0.5-0.1-0.8-0.2c-0.8-0.2-1.7-0.4-2.4-0.5l0,0c-0.4,0-0.7,0-1.1,0.1c-0.6,0-1.3,0-1.9,0.1 c0,0,0,0-0.1,0c-0.4,0.1-0.7,0.3-1.1,0.4C132.8,41.3,132.2,41.4,131.7,41.7L131.7,41.7L131.7,41.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: -2887.9761,
    y1: 72.5311,
    x2: -2867.9766,
    y2: 107.1713,
    gradientTransform: "matrix(-1 0 0 -1 -2747.8403 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M115.2,92.6c-0.4-0.2-0.8-0.4-1.1-0.4c-0.1,0-0.1,0-0.1,0l0.5-0.3c1.1-0.6,1.3-2.5,0.3-4.5 c-2.1-4.6-4.7-9-7.8-13c-0.5-0.7-1.1-1.2-1.7-1.5c-0.8-0.5-1.6-0.6-2.2-0.2l-0.6,0.3v-0.1c0.6-1.6-0.3-4.2-2-5.7 c-0.2-0.2-0.5-0.4-0.7-0.6l26.8-15.3l4.9-2.8h0.1c0.2-0.1,0.5-0.2,0.7-0.3s0.5-0.2,0.7-0.3c0.2,0,0.3-0.1,0.5-0.1h0.1 c0.1,0,0.1,0,0.2,0c0.3,0,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.9,0c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.2,0,0.4,0,0.5,0.1 c0.4,0.1,0.8,0.1,1.2,0.3c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.6,0.3,1.3,0.6,2,1 c0.9,0.5,1.8,1.2,2.7,1.8c0.3,0.2,0.5,0.5,0.8,0.7c0.4,0.4,0.8,0.7,1.2,1.1c0.2,0.2,0.4,0.4,0.5,0.6c0.2,0.2,0.3,0.3,0.5,0.5 s0.4,0.4,0.5,0.6c0.4,0.5,0.8,0.9,1.1,1.4c0.1,0.2,0.2,0.3,0.4,0.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.3,0.4,0.5 c0.3,0.4,0.6,0.8,0.8,1.2c0.3,0.4,0.5,0.8,0.7,1.2c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0.2,0.3,0.4,0.7,0.6,1 c0.2,0.4,0.4,0.8,0.6,1.2c0.2,0.4,0.3,0.7,0.5,1.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0.2,0.4,0.4,0.8,0.5,1.3c0.2,0.4,0.3,0.9,0.5,1.3 c0.1,0.2,0.1,0.4,0.2,0.7c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0.1,0.3,0.1,0.5c0.1,0.5,0.3,1.1,0.4,1.6c0.1,0.3,0.1,0.7,0.2,1 c0,0.2,0.1,0.3,0.1,0.5s0.1,0.3,0.1,0.5c0.1,0.9,0.2,1.9,0.2,2.8c0,4.5-1.6,7.6-4.1,9.1l-4.9,2.9l-27.3,15.6 c-0.3-1.6-0.6-3.1-1.1-4.7C117.7,94.9,116.5,93.4,115.2,92.6z"
  })))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M107.9,53.3l-0.3,0.1C107.7,53.4,107.8,53.3,107.9,53.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M26.2,143c1.2-2.4,5-5.5,8-7.2L130,80.3l6.4-3.7c0.2,0.6,0.4,1.1,0.6,1.7c0.1,0.2,0.2,0.4,0.2,0.7 c1,3.3,1.6,6.6,1.6,9.7c0,1.5-0.1,2.9-0.4,4.2c-0.1,0.4-0.3,0.8-0.4,1.2c-0.2,0.8-0.4,1.6-0.7,2.3c0,0.1-0.1,0.1-0.1,0.2l-5.7,3.2 l-94.6,52.4c-2.3,1.3-5.1,1.3-7.4,0.1L29,152C26.6,150.3,24.4,146.4,26.2,143z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M12.3,109.9L106.6,57l6.9-3.9c0.4,0.1,0.7,0.2,1.1,0.3c0.3,0.1,0.5,0.1,0.8,0.2c0.2,0.1,0.5,0.2,0.7,0.2 c0.4,0.2,0.9,0.4,1.3,0.6l0,0c0.2,0.1,0.4,0.2,0.6,0.3c0.5,0.3,1.1,0.4,1.6,0.8c1.2,0.7,2.4,1.6,3.6,2.5c2.2,1.7,4.2,3.8,6,6.1 c-1.8,1-3.9,2.2-6.4,3.6c-26.1,14.8-89,50.5-99,56.2c-9,5.1-12.6-3.3-14-8.6C9.4,113.2,10.4,110.9,12.3,109.9z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M3.4,113c4.7-6.9,104.2-59.6,104.2-59.6l0.3-0.1c0.7-0.2,2.3-0.5,2.9-0.5c0.4,0,0.8-0.1,1.2-0.1 c0.5,0,1,0.1,1.5,0.3l-6.9,3.9l-94.3,52.9c-1.9,1.1-2.9,3.3-2.4,5.4c1.4,5.3,5,13.7,14,8.6c9.9-5.7,72.8-41.4,99-56.2 c2.5-1.4,4.7-2.7,6.4-3.6c0.5,0.6,1,1.2,1.4,1.9l0,0c0.9,1.3,1.8,2.6,2.6,4s1.6,2.9,2.2,4.4c0.3,0.7,0.6,1.5,0.9,2.3l-6.4,3.7 l-95.8,55.5c-3,1.7-6.8,4.8-8,7.2c-1.8,3.4,0.4,7.2,2.8,8.8l0.5,0.3c2.3,1.2,5.1,1.2,7.4-0.1l94.6-52.4l5.7-3.2 c-0.2,0.3-0.4,0.6-0.6,1c-0.3,0.6-0.6,1.2-1.1,1.6c-0.3,0.3-0.7,0.6-1,0.9c-0.2,0.2-0.5,0.3-0.4,0.3L32.2,158.6 c-2.2,1.2-4.7,1.7-7.2,1.1c-4.8-1.1-14.9-5.9-20-15.4C-2.1,131.3-0.7,118.9,3.4,113z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: -2836.1445,
    y1: 37.2508,
    x2: -2827.3069,
    y2: 52.5577,
    gradientTransform: "matrix(-1 0 0 -1 -2747.8403 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M26.2,143c1.2-2.4,5-5.5,8-7.2L130,80.3l6.4-3.7c0.2,0.6,0.4,1.1,0.6,1.7c0.1,0.2,0.2,0.4,0.2,0.7 c1,3.3,1.6,6.6,1.6,9.7c0,1.5-0.1,2.9-0.4,4.2c-0.1,0.4-0.3,0.8-0.4,1.2c-0.2,0.8-0.4,1.6-0.7,2.3c0,0.1-0.1,0.1-0.1,0.2l-5.7,3.2 l-94.6,52.4c-2.3,1.3-5.1,1.3-7.4,0.1L29,152C26.6,150.3,24.4,146.4,26.2,143z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -2820.7615,
    y1: 65.4648,
    x2: -2811.3645,
    y2: 81.7411,
    gradientTransform: "matrix(-1 0 0 -1 -2747.8403 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M12.3,109.9L106.6,57l6.9-3.9c0.4,0.1,0.7,0.2,1.1,0.3c0.3,0.1,0.5,0.1,0.8,0.2c0.2,0.1,0.5,0.2,0.7,0.2 c0.4,0.2,0.9,0.4,1.3,0.6l0,0c0.2,0.1,0.4,0.2,0.6,0.3c0.5,0.3,1.1,0.4,1.6,0.8c1.2,0.7,2.4,1.6,3.6,2.5c2.2,1.7,4.2,3.8,6,6.1 c-1.8,1-3.9,2.2-6.4,3.6c-26.1,14.8-89,50.5-99,56.2c-9,5.1-12.6-3.3-14-8.6C9.4,113.2,10.3,110.9,12.3,109.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -2830.2886,
    y1: 31.8544,
    x2: -2802.3447,
    y2: 80.2544,
    gradientTransform: "matrix(-1 0 0 -1 -2747.8403 162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112087,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09937194,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3732,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6517,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    style: {
      stopColor: "#4E4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M3.4,113c4.7-6.9,104.2-59.6,104.2-59.6l0.3-0.1c0.7-0.2,2.3-0.5,2.9-0.5c0.4,0,0.8-0.1,1.2-0.1 c0.5,0,1,0.1,1.5,0.3l-6.9,3.9l-94.3,52.9c-1.9,1.1-2.9,3.3-2.4,5.4c1.4,5.3,5,13.7,14,8.6c9.9-5.7,72.8-41.4,99-56.2 c2.5-1.4,4.7-2.7,6.4-3.6c0.5,0.6,1,1.2,1.4,1.9l0,0c0.9,1.3,1.8,2.6,2.6,4s1.6,2.9,2.2,4.4c0.3,0.7,0.6,1.5,0.9,2.3l-6.4,3.7 l-95.8,55.5c-3,1.7-6.8,4.8-8,7.2c-1.8,3.4,0.4,7.2,2.8,8.8l0.5,0.3c2.3,1.2,5.1,1.2,7.4-0.1l94.6-52.4l5.7-3.2 c-0.2,0.3-0.4,0.6-0.6,1c-0.3,0.6-0.7,1.2-1.1,1.6c-0.3,0.3-0.7,0.6-1,0.9c-0.2,0.2-0.5,0.3-0.4,0.3L32.2,158.6 c-2.2,1.2-4.7,1.7-7.2,1.1c-4.8-1.1-14.9-5.9-20-15.4C-2.1,131.3-0.7,118.9,3.4,113z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.417f5cd870e51c7226c113f0336bf567.svg";
export { ForwardRef as ReactComponent };